module.exports = __webpack_public_path__ + "img/icon-calc2.7eebef28.svg";